import { useEffect, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

import SortIcon from "../ui-icons/table/SortIcon";
import { urlDefault } from "src/constants";
import { siteUrlOrSiteApi } from "src/api/config/systemSwitch";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";
import { EmptyList } from "../EmptyList";
import { TooltipItem } from "src/utils/Tooltip";
import { Statuses5WayNotice } from "src/pages/DashboardPage/throughcomponents/incidentCard/components/statusesNotice/statusesNotice";

function safeUserDisplayNameByEmail(users: any, email: string | null | undefined): string | null {
    if (!email) return null;

    const user = users?.[email.toLowerCase()];
    return user?.displayName || user?.fullName || null;
}

const MyTasksIncidentsTable = (props: any) => {

    const { data, setExportData, customLoading, statuses, fieldsFromExel, typeN } = props;
    const [sortData, setSortData] = useState<any>([]);
    const [query, setQuery] = useSearchParams();
    const users: any = useAppSelector(selectUsers);

    const [tableHeaderContent, setTableHeaderContent] = useState<any>({});

    const [tableHeaderContentExel, setTableHeaderContentExel] = useState<any>({});

    const openDocumentCard = (id: number) => {
        const newSearchParams = new URLSearchParams(query);
        newSearchParams.set("incidentCardMobile", id.toString());
        setQuery(newSearchParams);
    }

    const sortDataHandle = (sortField: string, sortDirection: string, sortType: string) => {
        const tempTableHeaderContent = { ...tableHeaderContent };
        const tempData = [...data.map((item: any) => { return { ...item, ...{ ActionsStatusStr: item.actionsStatus.name, ResponsibleStr: users[item.ResponsibleEmail.toLowerCase()] && users[item.ResponsibleEmail.toLowerCase()]['displayName'], RegionStr: item.Region.get_lookupValue(), DepartmentStr: item.Department.get_lookupValue(), LocationStr: item.Location.get_lookupValue(), closedDaysCount: moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') <= 0 && 0 || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days'), StatusStr: item.Status.get_lookupValue() } } })];
        Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        if (sortDirection === 'default') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'desc';
        }
        if (sortDirection === 'desc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'asc';
        }
        if (sortDirection === 'asc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'default';
            setSortData([...data]);
        }
        if (sortType === 'number') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => parseFloat(a[sortField]) - parseFloat(b[sortField]));
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => parseFloat(b[sortField]) - parseFloat(a[sortField]));
            }
        }
        if (sortType === 'string') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => {
                    return a[sortField].localeCompare(b[sortField]);
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => {
                    return b[sortField].localeCompare(a[sortField]);
                });
            }
        }
        if (sortType === 'date') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateA.getTime() - dateB.getTime();
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateB.getTime() - dateA.getTime();
                });
            }
        }
        setTableHeaderContent({ ...tempTableHeaderContent });
        setSortData([...tempData]);
    }

    useEffect(() => {
        setTableHeaderContent({
            ID: {
                title: '№',
                sort: true,
                style: { width: "4.7%" },
                sortDirection: 'default',
                sortType: 'number'
            },
            DateIncidents: {
                title: "Дата регистрации",
                sort: true,
                style: { width: "11.71%" },
                sortDirection: 'desc',
                sortType: 'date'
            },
            DateIncidents2: {
                title: typeN && "Дата несоответствия" || "Дата инцидента",
                sort: true,
                style: { width: "11.71%" },
                sortDirection: 'desc',
                sortType: 'date'
            },
            StatusStr: {
                title: "Статус",
                sort: true,
                style: { width: "13.40%" },
                sortDirection: 'default',
                sortType: 'string'
            },
            ResponsibleStr: {
                title: "ФИО инициатора",
                sort: true,
                style: { width: "12.04%" },
                sortDirection: 'default',
                sortType: 'string'
            },
            LocationStr: {
                title: "Локация",
                sort: true,
                style: { width: "7.36%" },
                sortDirection: 'default',
                sortType: 'string'
            },
            DepartmentStr: {
                title: "Отдел",
                sort: true,
                style: { width: "11.04%" },
                sortDirection: 'default',
                sortType: 'string'
            },
            RegionStr: {
                title: "Участок",
                sort: true,
                style: { width: "5.35%" },
                sortDirection: 'default',
                sortType: 'string'
            },
            ActionsStatusStr: {
                title: "Статус действий",
                sort: true,
                style: { width: "10.02%" },
                sortDirection: 'default',
                sortType: 'string'
            },
            closedDaysCount: {
                title: typeN && "Кол-во дней до закрытия несоответствия" || "Кол-во дней до окончания расследования",
                sort: true,
                style: { width: "15.05%" },
                sortDirection: 'default',
                sortType: 'number'
            }
        });
        setTableHeaderContentExel({
            ID: {
                title: '№',
                width: 50
            },
            DateIncidents: {
                title: "Дата регистрации",
                width: 50
            },
            DateIncidents2: {
                title: typeN && "Дата несоответствия" || "Дата инцидента",
                width: 50
            },
            StatusStr: {
                title: "Статус",
                width: 50
            },
            ResponsibleStr: {
                title: "ФИО инициатора",
                width: 50
            },
            LocationStr: {
                title: "Локация",
                width: 50
            },
            DepartmentStr: {
                title: "Отдел",
                width: 50
            },
            RegionStr: {
                title: "Участок",
                width: 50
            },
            Description: {
                title: "Описание",
                width: 50
            },
            TypeIncident: {
                title: "Тип несоответствия/инцидента",
                width: 50
            },
            tree: {
                title: "Корневые причины",
                width: 50
            },
            actions: {
                title: "Действия",
                width: 50
            },
            ActionsStatusStr: {
                title: "Статус действий",
                width: 50
            },
            closedDaysCount: {
                title: typeN && "Кол-во дней до закрытия несоответствия" || "Кол-во дней до окончания расследования",
                width: 50
            }
        });
    }, [typeN]);

    useEffect(() => {
        if (fieldsFromExel.length > 0) {
            setSortData([...data]);
            const tempTableHeaderContent = { ...tableHeaderContent };
            Object.keys(tempTableHeaderContent).map((key: string) => {
                tempTableHeaderContent[key]['sortDirection'] = 'default';
            });
            setTableHeaderContent({ ...tempTableHeaderContent });
            if (data.length > 0) {
                const inc = data[0];
                const incQuestions = inc.Questions && JSON.parse(inc.Questions);
                if (incQuestions && Object.keys(incQuestions).length > 0) {
                    let fieldsExel: any = {};
                    Object.keys(incQuestions).forEach(key => {
                        if (key === 'QAIncidentQEquipments' || key === 'QAIncidentPEquipments' || key === 'MIncEq' || key === 'MNEq') {
                            if (key === 'MIncEq' || key === 'MNEq') {
                                fieldsExel['SAP_MESSAGE'] = {
                                    title: 'SAP номер сообщения',
                                    width: 50,
                                    order: 20
                                }
                            }
                            fieldsExel['SAP'] = {
                                title: 'SAP № технического места',
                                width: 50,
                                order: 20
                            }
                            fieldsExel['Equipments_Title'] = {
                                title: 'Название оборудования',
                                width: 50,
                                order: 20
                            }
                            fieldsExel['Equipments_Manufacturer'] = {
                                title: 'Производитель оборудования',
                                width: 50,
                                order: 20
                            }
                            fieldsExel['Equipments_Model'] = {
                                title: 'Модель оборудования',
                                width: 50,
                                order: 20
                            }
                            fieldsExel['Equipments_TypeEquipment'] = {
                                title: 'Тип оборудования',
                                width: 50,
                                order: 20
                            }
                        } else {
                            fieldsExel[key.replace(/\d/g, '')] = {
                                title: fieldsFromExel.find((field: any) => field.key === key) && fieldsFromExel.find((field: any) => field.key === key)['title'] || key.replace(/\d/g, ''),
                                width: 50,
                                order: 10
                            }
                        }
                    });
                    let tempTableHeaderContentExel = {
                        ID: {
                            title: '№',
                            width: 50
                        },
                        DateIncidents: {
                            title: "Дата регистрации",
                            width: 50
                        },
                        DateIncidents2: {
                            title: typeN && "Дата несоответствия" || "Дата инцидента",
                            width: 50
                        },
                        StatusStr: {
                            title: "Статус",
                            width: 50
                        },
                        ResponsibleStr: {
                            title: "ФИО инициатора",
                            width: 50
                        },
                        LocationStr: {
                            title: "Локация",
                            width: 50
                        },
                        DepartmentStr: {
                            title: "Отдел",
                            width: 50
                        },
                        RegionStr: {
                            title: "Участок",
                            width: 50
                        },
                        Description: {
                            title: "Описание",
                            width: 50
                        },
                        TypeIncident: {
                            title: "Тип несоответствия/инцидента",
                            width: 50
                        },
                        ActionsStatusStr: {
                            title: "Статус действий",
                            width: 50
                        },
                        tree: {
                            title: "Корневые причины",
                            width: 50
                        },
                        actions: {
                            title: "Действия",
                            width: 50
                        },
                        closedDaysCount: {
                            title: typeN && "Кол-во дней до закрытия несоответствия" || "Кол-во дней до окончания расследования",
                            width: 50
                        },
                        ...fieldsExel
                    };
                    setTableHeaderContentExel({ ...tempTableHeaderContentExel });
                }
            }
        }
    }, [data, fieldsFromExel]);

    useEffect(() => {
      setSortData([...data]);
    }, [data]);

    useEffect(() => {
        if (sortData.length > 0) {
            let exportColumns: any = [];
            Object.keys(tableHeaderContentExel).map((key: any) => {
                exportColumns = [...exportColumns, {
                    header: tableHeaderContentExel[key]['title'],
                    key: key,
                    width: tableHeaderContentExel[key]['width'],
                    order: tableHeaderContentExel[key]['order']
                }]
            });
            let exportData: any = [];
            sortData.forEach((item: any) => {
                let fieldsExelData: any = {};
                const incQuestionsData = item.Questions && JSON.parse(item.Questions) || {};
                if (Object.keys(incQuestionsData).length > 0) {
                    Object.keys(incQuestionsData).forEach(key => {
                        if (typeof incQuestionsData[key] === 'string' || typeof incQuestionsData[key] === 'number') {
                            fieldsExelData[key.replace(/\d/g, '')] = incQuestionsData[key]
                        } else if (Array.isArray(incQuestionsData[key])) {
                            if (!Array.isArray(fieldsExelData[key.replace(/\d/g, '')])) {
                                fieldsExelData[key.replace(/\d/g, '')] = [];
                            }
                            if (key === 'QAIncidentQEquipments' || key === 'QAIncidentPEquipments' || key === 'MIncEq' || key === 'MNEq') {
                                if (key === 'MIncEq' || key === 'MNEq') {
                                    fieldsExelData['SAP_MESSAGE'] = incQuestionsData[key].map((item: any) => item.SAP_MESSAGE).join(`;\u000A`)
                                }
                                fieldsExelData['SAP'] = incQuestionsData[key].map((item: any) => item.SAP && item.SAP.SAP || '').join(`;\u000A`)
                                fieldsExelData['Equipments_Title'] = incQuestionsData[key].map((item: any) => item.SAP && item.SAP.Title || '').join(`;\u000A`)
                                fieldsExelData['Equipments_Manufacturer'] = incQuestionsData[key].map((item: any) => item.SAP && item.SAP.Manufacturer || '').join(`;\u000A`)
                                fieldsExelData['Equipments_Model'] = incQuestionsData[key].map((item: any) => item.SAP && item.SAP.Model || '').join(`;\u000A`)
                                fieldsExelData['Equipments_TypeEquipment'] = incQuestionsData[key].map((item: any) => item.SAP && item.SAP.TypeEquipment || '').join(`;\u000A`)
                            } else {
                                fieldsExelData[key.replace(/\d/g, '')] = incQuestionsData[key].join(', ');
                            }
                        } else {
                            fieldsExelData[key.replace(/\d/g, '')] = incQuestionsData[key]['name'];
                        }
                    });
                }
                exportData = [...exportData, {
                    ID: {
                        text: item.ID,
                        hyperlink: `${siteUrlOrSiteApi}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${item.ID}`,
                        tooltip: item.Title
                    },
                    DateIncidents: moment(item.DateIncidents).isValid() && moment(item.DateIncidents).format('DD.MM.YYYY') || "-",
                    DateIncidents2: moment(item.DateIncidents2).isValid() && moment(item.DateIncidents2).format('DD.MM.YYYY') || "-",
                    StatusStr: item.Status.get_lookupValue(),
                    ResponsibleStr: users[item.ResponsibleEmail.toLowerCase()] && users[item.ResponsibleEmail.toLowerCase()]['displayName'],
                    LocationStr: item.Location.get_lookupValue(),
                    DepartmentStr: item.Department.get_lookupValue(),
                    RegionStr: item.Region.get_lookupValue(),
                    ActionsStatusStr: item.actionsIncStatus.name,
                    Description: item.Description,
                    TypeIncident: item.TypeIncident.get_lookupValue(),
                    closedDaysCount: (item.Status.get_lookupId() === 2 || item.Status.get_lookupId() === 4 || item.Status.get_lookupId() === 5 || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') < 0) && '-' || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') === 0 && 0 || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days'),
                    tree: item.tree,
                    actions: item.actions.map((action: any) => action.Description).join(`,\u000A`) || '-',
                    ...fieldsExelData
                }]
            });
            setExportData({ columns: [...exportColumns.sort((a: any, b: any) => parseFloat(a['order']) - parseFloat(b['order']))], data: [...exportData] });
        }
    }, [sortData, users, tableHeaderContentExel]);

    return (
        <FlexCol className="w-full">
            <FlexCol className="relative">
                <FlexCol id="owd_calendar_wrapper" className="relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar-none scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-210px)] min-h-[170px]">
                    <FlexCol className="pb-5 sticky-custom h-fit w-full bg-white pt-5 px-[16px] gap-5 z-10 hidden">
                        {Object.keys(tableHeaderContent).map((fieldKey, index) => {
                            const key: string = fieldKey;
                            return (
                                <TableHeaderColumn
                                    key={fieldKey + '_' + index}
                                    sortField={fieldKey}
                                    tableHeaderContent={tableHeaderContent[key]}
                                    sortDataHandle={sortDataHandle}
                                />
                            );
                        })}
                    </FlexCol>
                    <FlexCol className="divide-y grow w-full px-[8px] min-w-full">
                        {sortData.map((item: any, index: any) => (
                            <FlexCol
                                className="py-4 -mx-2 px-[16px] gap-[4px] cursor-pointer text-[#637381] hover:bg-[#F3F4F6]"
                                key={item.ID + '_' + index}
                                onClick={() => openDocumentCard(item.ID)}
                            >
                                <FlexRow style={{ width: "100%" }} className="break-words relative gap-[8px]" >
                                    <TooltipItem wrapperClassName="" position="bottom-right" tooltipsReactNode={<Statuses5WayNotice statuses={statuses} typeInc={JSON.parse(item.Questions)['IncidentOption'] || ''} />} tooltipsText="" className="w-[600px] left-0">
                                        <div className="flex items-center shrink-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 10 10" fill="none">
                                                <circle
                                                    cx="5"
                                                    cy="5"
                                                    r="5"
                                                    fill={
                                                        (item.Status_x003a_Color && item.Status_x003a_Color.get_lookupValue && item.Status_x003a_Color.get_lookupValue()) ||
                                                        (item.Status && statuses && statuses.find((s: any) => s.ID === item.Status.get_lookupId()) && statuses.find((s: any) => s.ID === item.Status.get_lookupId()).Color) ||
                                                        "#D1D5DB"
                                                    }
                                                />
                                            </svg>
                                        </div>
                                    </TooltipItem>
                                    <span className="block text-[14px] font-normal not-italic text-[#012169]">{moment(item.DateIncidents).isValid() && moment(item.DateIncidents).format('DD.MM.YYYY') || "-"}</span>
                                </FlexRow>
                                <FlexCol style={{ width: "100%" }} className="break-words">
                                    <span className="block text-[13px] font-normal not-italic">{safeUserDisplayNameByEmail(users, item.ResponsibleEmail) || <span>Пользователь не активен</span>}</span>
                                </FlexCol>
                                <FlexRow style={{ width: "100%" }} className="break-words">
                                    <span className="inline text-[13px] font-normal not-italic">{item.Location.get_lookupValue() + '/' + item.Department.get_lookupValue() + '/' + item.Region.get_lookupValue()}</span>
                                </FlexRow>
                                <FlexRow>
                                    <span className="block text-[13px] font-normal not-italic">Действия запланированы: {item.actionsIncStatus['name'] === 'Нет действий' ? 'Нет' : 'Да'}</span>
                                </FlexRow>
                            </FlexCol>
                        ))}
                    </FlexCol>
                    {!customLoading && data.length === 0 &&
                        <FlexCol className="justify-center items-center absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                            <EmptyList title="Данные не найдены" />
                        </FlexCol>
                    }
                </FlexCol>
                {!customLoading && data.length > 0 && <div className="w-full my-2 py-2 text-center bg-[#012169] text-white">Список сформирован</div>}
                {customLoading && <div className="w-full my-2 py-2 text-center animate-pulse">Формируется список, пожалуйста подождите</div>}
            </FlexCol>
        </FlexCol>
    );
}

export default MyTasksIncidentsTable;

export function TableHeaderColumn({ tableHeaderContent, sortDataHandle, sortField }: any) {
    return (
        <FlexCol className="select-none" style={tableHeaderContent.style}>
            <FlexRow className="gap-x-2">
                {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
                <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
                {tableHeaderContent.sort && (
                    <FlexCol className="w-auto cursor-pointer" onClick={() => sortDataHandle(sortField, tableHeaderContent.sortDirection, tableHeaderContent.sortType)}>
                        <SortIcon sortDirection={tableHeaderContent.sortDirection} />
                    </FlexCol>
                )}
            </FlexRow>
        </FlexCol>
    );
}
